import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { BaseFieldProps } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import { LabelFieldParams } from 'SharedDir/declarations/fields';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'LabelField' },
  __name: 'LabelField',
  props: {
    label: { default: '' },
    showHistory: { type: Boolean },
    history: {},
    params: {}
  },
  setup(__props: any) {



const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
      'text-body2': _ctx.params.size === 'normal',
      'text-h4': _ctx.params.size === 'header',
      'text-bold': _ctx.params.bold,
      'text-italic': _ctx.params.italic,
    }, "text-justify"])
  }, _toDisplayString(_ctx.params.text), 3))
}
}

})